import { useContext } from 'react'
import {
  AppearanceContext,
  type ResolvedTheme,
  type ThemePreference,
} from '@/shared/components/appearance-context'

export type { ResolvedTheme, ThemePreference }

/** Préférence de thème (auto/clair/sombre) + thème résolu, via AppearanceProvider. */
export function useTheme() {
  const ctx = useContext(AppearanceContext)
  if (!ctx) {
    throw new Error('useTheme must be used within an AppearanceProvider')
  }
  return { theme: ctx.theme, resolvedTheme: ctx.resolvedTheme, setTheme: ctx.setTheme }
}
